// Import model
import { LeadNoteCondition } from '../models/LeadNoteCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { LeadNoteIndexedFields } from '../models/LeadNoteIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { LeadNoteIndexedFieldsSerializer } from './LeadNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadNoteCondition - handles JSON serialization and deserialization with type validation
 */
export class LeadNoteConditionSerializer {
  /**
   * Deserializes a JSON string into a LeadNoteCondition instance
   */
  static deserialize(json: string): LeadNoteCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadNoteCondition instance
   */
  static fromObject(obj: any): LeadNoteCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadNoteCondition');
    }


    const instance: LeadNoteCondition = {
      fieldName: obj['fieldName'] as LeadNoteIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadNoteCondition instances
   */
  static deserializeArray(json: string): LeadNoteCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadNoteCondition instance to a JSON string
   */
  static serialize(instance: LeadNoteCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadNoteCondition instance to a plain object
   */
  static toObject(instance: LeadNoteCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of LeadNoteCondition instances to a JSON string
   */
  static serializeArray(instances: LeadNoteCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
